// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partnersView_wrapper__AYhHe {
  width: 85%;
  padding: 30px;
  margin-left: auto;
  text-align: left;
}

.partnersView_header__VZ9dX {
  display: flex;
  justify-content: flex-start;
  gap: 40px; 
  border-bottom: 2px solid #e0e0e0;
  max-width: 280px; 
  position: relative;
  margin-bottom: 1.25rem;
}

.partnersView_tabButton__6Xr2b {
  background: none;
  border: none;
  font-size: 18px;
  padding: 10px 16px;
  position: relative;
  cursor: pointer;
  color: #333;
}

.partnersView_active__W5ZMq {
  color: rgba(29, 135, 82, 1);
}

.partnersView_active__W5ZMq::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  height: 2px;
  width: 100%;
  background-color: rgba(29, 135, 82, 1);
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/partnersView.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,sCAAsC;EACtC,UAAU;AACZ","sourcesContent":[".wrapper {\n  width: 85%;\n  padding: 30px;\n  margin-left: auto;\n  text-align: left;\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  gap: 40px; \n  border-bottom: 2px solid #e0e0e0;\n  max-width: 280px; \n  position: relative;\n  margin-bottom: 1.25rem;\n}\n\n.tabButton {\n  background: none;\n  border: none;\n  font-size: 18px;\n  padding: 10px 16px;\n  position: relative;\n  cursor: pointer;\n  color: #333;\n}\n\n.active {\n  color: rgba(29, 135, 82, 1);\n}\n\n.active::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  height: 2px;\n  width: 100%;\n  background-color: rgba(29, 135, 82, 1);\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `partnersView_wrapper__AYhHe`,
	"header": `partnersView_header__VZ9dX`,
	"tabButton": `partnersView_tabButton__6Xr2b`,
	"active": `partnersView_active__W5ZMq`
};
export default ___CSS_LOADER_EXPORT___;
